import { Reducer } from 'redux';

import { changeAnyWallet } from 'reduxState/wallet/walletReducer';

// Actions

export const clearBankrollCode = () => ({
  type: 'CLEAR_BANKROLL_CODE' as const,
});

export const setBankrollCode = (
  code: string | undefined,
  codeType: 'bankroll' | 'welcomePoints'
) => ({
  type: 'SET_BANKROLL_CODE' as const,
  code,
  codeType,
});

export const setBankrollCodeApplied = (message?: string) => ({
  type: 'SET_BANKROLL_CODE_APPLIED' as const,
  message,
});

// Reducer

type UserBankroll = {
  /** @cached code to be applied with type prefix like "points:123456" / "bankroll:123456"  */
  // bankrollCodeToApply?: `bankroll:${string}` | `points:${string}`;
  bankrollCodeToApply?: string;
  bankrollCodeType?: 'bankroll' | 'welcomePoints';

  /** Prevents pernamently displaying after page refresh */
  bankrollAddedInThisSession?: boolean;

  /** Not cached redeemed code */
  bankrollCodeApplied?: string;

  /** Not cached redeemed message (optional) */
  bankrollCodeAppliedMessage?: string;
};

type BankrollAction =
  | ReturnType<
      | typeof setBankrollCode
      | typeof setBankrollCodeApplied
      | typeof clearBankrollCode
    >
  | changeAnyWallet;

const defaultState: UserBankroll = {
  bankrollCodeToApply: undefined,
  bankrollCodeType: undefined,
  bankrollCodeApplied: undefined,
  bankrollCodeAppliedMessage: undefined,
  bankrollAddedInThisSession: undefined,
};

/** @cached */
export const userBankrollReducer: Reducer<UserBankroll, BankrollAction> = (
  state = defaultState,
  action
): UserBankroll => {
  switch (action.type) {
    case 'CHANGE_WALLET':
      return { ...state };
    case 'CLEAR_BANKROLL_CODE':
      return defaultState;
    case 'SET_BANKROLL_CODE':
      return {
        ...state,
        bankrollCodeToApply: action.code,
        bankrollCodeType: action.codeType,
        bankrollCodeApplied: undefined,
        bankrollCodeAppliedMessage: undefined,
        bankrollAddedInThisSession: !!action.code,
      };
    case 'SET_BANKROLL_CODE_APPLIED':
      return {
        ...state,
        // Remove existing applied code
        bankrollCodeToApply: undefined,
        bankrollCodeApplied: state.bankrollCodeToApply,
        bankrollCodeAppliedMessage: action.message,
      };
    default:
      return state;
  }
};
